module.exports = __webpack_public_path__ + "static/img/公司16.75b8d1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司16.jpg
// module id = 0jYw
// module chunks = 1